import React, { useEffect, useState } from "react"
import SideBar from "../SideBar"
import Header from "../header"
import { GlobalService } from "../service/GlobalService"
import axios from "axios"
import ExportToExcel from "../ExportToExcel"
import Pagination from "react-js-pagination"
import { Button } from "@mui/material"
import { Link } from "react-router-dom"


export const DamagematerialList = () => {
 
    const [tableData, setTableData] = useState()


    useEffect(() => {
        const getProductDetails = async (e) => {
            const res = await axios.get(`${GlobalService.path}/fetchDamage`)
           
            setTableData(res.data.data)
          
        }
        getProductDetails()
    }, [])

    const [searchQuery, setSearchQuery] = useState("");


    const itemsPerPage = 10; // Number of items to display per page
    const allItems = tableData; // Your array of items

    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const filteredItems = allItems
        ? allItems.filter((item) =>
            Object.values(item)
                .join(" ")
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
        : [];
    const itemsToShow = filteredItems.slice(startIndex, endIndex);

    const totalPageRange = 2; // Number of pages to display
    
    

    const deleteItem = async (id) => {
        try {
            const response = await axios.delete(`${GlobalService.path}/deleteMaterialDamage/${id}`);
            if (response.status == 200) {
                alert("Record deleted successfully")
                window.location.reload()
            } else alert('Failed to Delete')


        } catch (error) {
            alert('Failed to delete record')
            console.error('Error deleting item:', error);
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value)
        setCurrentPage(1)
    }

    return (
        <div className="page-container">
            {/* Page Sidebar */}
            <SideBar />
            {/* /Page Sidebar */}
            {/* Page Content */}
            <div className="page-content">
                {/* Page Header */}
                <Header />
                {/* /Page Header */}
                {/* Page Inner */}

                <div className="panel panel-white" >

                    <div className='row'>
                        <div className='col-md-4'>
                        <a
                        type="button"
                        className="btn btn-success m-b-sm"
                        href="materialDamage"
                    >
                        Add Damage Material
                    </a>
                        </div>
                        <div className='col-md-7'>
                            <input
                                type="text"
                                className="form-control col-md-6"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => handleSearchChange(e)}
                            />
                        </div>
                        <div className='col-md-1  text-end'>
                            <ExportToExcel data={filteredItems} />
                        </div>
                    </div>
                    <div className="page-title row">
                        <div className="col-md-10">
                            <h3 className="breadcrumb-header">Damage Material List</h3>
                        </div>
                        <div className="col-md-2 text-end">

                        </div>

                    </div>
                    <div id="main-wrapper">
                        <div className="table-container">
                            <table className="table display">
                                <thead className="sticky-header">
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Product Name</th>
                                        <th>HSN</th>
                                        <th>Total Weight</th>
                                        <th>Type</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {itemsToShow && itemsToShow?.length > 0 ?
                                        (itemsToShow.map((row, index) => (
                                            <tr>

                                                <td>{index + 1}</td>
                                                <td style={{width:"20%"}}>{row.prod_name}</td>
                                                <td>{row.hsn}</td>
                                                <td>{row.total_weight}</td>
                                                <td>{row.type}</td>
                                                <td>
                                                
                                                   
                                                    <Link className="confirm-text" style={{marginLeft:"10px",cursor:"pointer"}}  onClick={() => deleteItem(row.dam_id)}>
                                                    <i
                                                    className="fa fa-trash"
                                                    style={{ color: "red", fontSize: "18px" }}
                                                  ></i> </Link>
                                                </td>
                                            </tr>
                                        ))) : (<tr><td>No Data Available</td></tr>)}

                                </tbody>
                            </table>
                        </div>
                        <Pagination
                            activePage={currentPage}
                            itemsCountPerPage={itemsPerPage}
                            totalItemsCount={allItems?.length}
                            pageRangeDisplayed={totalPageRange} // Number of visible page links
                            onChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>
        </div>
)
}